import React, { useState } from "react";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Textfield from "../../components/formikcomponent/TextField";
import Selectoption from "../../components/formikcomponent/SelectFieldWithLabel";
import SuccessDialog from '../../components/SuccessDialog';
import ErrorDialog from '../../components/ErrorDialog';
import DiseaseSegment from'../../components/Fields/DiseaseSegment';
import {string, number, mixed, array, object} from 'yup';
import JsonPreviewCur from './AFBPreview';
import { Typography, makeStyles, Button, Grid, Paper,} from '@material-ui/core';
import { Formik, Field, Form,} from "formik";
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import Resourceid  from '../../components/Fields/Resource';
import Persona from'../../components/Fields/Persona';
import TreatmentPhase from "../../components/Fields/TreatmentPhase";
import DrugCategory from "../../components/Fields/DrugCategory";
import CircularProgress from '@material-ui/core/CircularProgress';
import Fieldtext from '../../components/Fields/FieldText';
import Constants from '../../components/Fields/DropDownList';
import Trigger from '../../components/Fields/Trigger';
import CategoryTag from '../../components/Fields/CategoryTag';
import TopicTag from '../../components/Fields/TopicTag';
import Objective from "../../components/Fields/Objective";
import {StatusCodes} from 'http-status-codes';
import AreaField from '../../components/Fields/VeevaContentId';
import {AFBCUR} from "../../components/CSSDuplicatedBlocks";

const bgcolor = "rgba(75, 123, 227, 1)";
const bgcolor2 = "rgb(243, 244, 245)";
const useStyles = makeStyles(theme => ({
    primaryBtn: { color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main,
    border: `1px solid${theme.palette.border.primaryBorder}`, borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 20px", textTransform: "uppercase",
    '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`} },
    createUser: {
      minWidth: "242px !important", textTransform: "uppercase", backgroundColor: bgcolor, color: '#fff', borderRadius: "25px", border: "1px solid ",
      marginLeft: "16px", fontWeight: "500 !important",
      '&:hover': { color: bgcolor,  border: "1px solid #fff" },
      [theme.breakpoints.down("sm")]: {
          width: "70%",
          marginLeft:"-15px"
      }
    },
    lightTooltipTimeToTake: {
          maxWidth: 150,
          minWidth:150,
          color: 'rgba(74, 74, 74, 1)',
          fontSize: 12,
          border: '1px solid #dadde9',
          boxShadow: "0px 1px 0px -6px rgba(0,0,0,0.2), 0px 1px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
      },
  DeleteUser: {

    '&:hover': { color: bgcolor2, border: "1px solid " },
    [theme.breakpoints.down("sm")]: {
      top: "-90px"
    },
    border: "none",
    backgroundColor: bgcolor2,
    borderRadius: "50%",
    position: "absolute", right: "6px",
    padding: "8px",
  },
   fieldarraypadding:{paddingTop:"30px"},
    cancelBtn: { width: "242px", height: "36px", textTransform: "uppercase", backgroundColor: "rgba(255, 255, 255, 1)",
    color: bgcolor, borderRadius: "25px", border: "1px solid rgba(0, 0, 0, 0.12)", marginLeft: 25, fontWeight: "500 !important",
    '&:hover': { color: '#1d5d90',  border: "1px solid " },
    [theme.breakpoints.down("sm")]: {
        width: "80%",
        marginLeft:0
    }},
     adherencePopBdy: {
          padding: "1px",
      },
   chapterheading:{backgroundColor: bgcolor2,height:"80px", [theme.breakpoints.down("sm")]: {}},
    gridHeader: { paddingLeft: "5px", paddingBottom: "25px", paddingTop: "5px" },
    clr_title: { color: "rgba(74, 74, 74, 1)", fontSize: "17px" },
    button: { height: "40px", margin: "20px 0", marginRight: "20px", backgroundColor: "#2262bf",
    color: "white", paddingTop: "7px", width:'100%', paddingBottom: "7px", fontSize: "13.7px", whiteSpace: "nowrap", cursor: "pointer", borderRadius: "50px",
    [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" }, '&:hover': { opacity:'0.8', transition:'0.2s' , backgroundColor:'#2262bf'} },
    ...AFBCUR
  }));
const AddAFB = (props) => {
    const [open, setOpen] =  React.useState(false);
    const [openpopup, setOpenpopup] = React.useState(false);
    const [load, setLoad] = useState(false);
    const [headerText, setHeaderText] = useState('');
    const [popup, setPopup] = useState(false);
    const [errorPopup, setErrorPopup] = useState(false);
    const[disableafbsubmit,setDisableafbSubmit]= useState(false);
    const classes = useStyles();
    let fourty=40;
    const requiredMessage = "This field is required.";
    let validateWithSchema= object().shape({
        resourceid:string().required(requiredMessage),
        Frequency: number().required(requiredMessage).typeError("Frequency must be a number."),
        MessageTitle:string().required(requiredMessage).max(fourty, "You cannot enter more than 40 characters."),
        objective:mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage).typeError(requiredMessage),
        MessageBody:string().required(requiredMessage).max(StatusCodes.INTERNAL_SERVER_ERROR, "You cannot enter more than 500 characters."),
        trigger: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage).typeError(requiredMessage),
        categorytag: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage).typeError(requiredMessage),
        topictag: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage).typeError(requiredMessage),
        diseasesegment: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage).typeError(requiredMessage),
        persona: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage).typeError(requiredMessage),
        medicationType: string().ensure().required(requiredMessage),
        treatmentphase: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage),
        drugcategory: mixed().when('isArray', { is: Array.isArray, then: array().of(string()), otherwise: string()
        .typeError(requiredMessage), }).required(requiredMessage)
    });
    let initialValues = { resourceid:'', trigger:[], Frequency:'', categoryTag:[], topicTag:[], MessageTitle:'', MessageBody:'', diseasesegment:[], persona:[], medicationType:[] };
    const getObjectByLabel = (value, label) => {
    let setvalues=[];
    for (let i = 0; i < value.length; i++) {
    label.find((afbvalue) => {
      if (afbvalue.label === value[i]) {
        setvalues.push({ value: afbvalue.value, label: afbvalue.label });
      }
    });
    }
  return(setvalues);
  };
React.useEffect(()=>{
if (props.location.state) {
if(props.location.state.detail[0].versionNumber!==props.location.state.detail[0].Version.newversion&&props.location.clone !== "clone"){
setDisableafbSubmit(true);
}
}
},[]);
    const getObjectByValue = (value, options) => {
      return options.filter((element) => {
      return element.value === value;
      });
  };

  const getResourceId = (data) => {
    if(props.location.clone === "clone"){
      return null;
    }
    return data.resourceid;
  };
  let ObjectiveOptions = Constants.objectiveValue;
  let treatmentPhaseValue = Constants.treatmentPhaseValue;
  let drugCategoryarticleValue = Constants.drugCategoryValue;
  let triggerValue = Constants.triggeroption;
  let categorytagtAFBValue = Constants.categoryValue;
  let TopictagAFBValue = Constants.TopictagValue;
  let diseaseSegmentAFBValue = Constants.diseaseSegmentValue;
  let personaAFB = Constants.personaValue;
  const medicationType = [{ label: "Symptom", value: 1 }, { label: "AFB Generic Medication", value: 2 }];
  if(props.location.state){
    const data = props.location.state.detail[0];
  let veeva='';
  if(props.location.newversion_clone){
  veeva=data.veevacontentid;
  }
    initialValues = {
        resourceid: getResourceId(data),
        veevacontentid:veeva,
        trigger: getObjectByLabel(data.trigger, triggerValue),
        Frequency: data.content.frequency,
        categorytag: getObjectByLabel(data.categorytag, categorytagtAFBValue),
        topictag: getObjectByLabel(data.topictag, TopictagAFBValue),
        MessageTitle: data.content.messagetitle,
        MessageBody: data.content.messagebody,
        diseasesegment: getObjectByLabel(data.diseasesegment, diseaseSegmentAFBValue),
        persona: getObjectByLabel(data.persona, personaAFB),
        medicationType: getObjectByValue(data.category, medicationType),
        objective: getObjectByLabel(data.objective, ObjectiveOptions),
        treatmentphase: getObjectByLabel(data.treatmentphase, treatmentPhaseValue),
        drugcategory: getObjectByLabel(data.drugcategory, drugCategoryarticleValue)
    };
}
 const handleClose = () => {
    setOpen(false);
    setOpenpopup(false);
  };
 const handlePreviewcur = () => {
    setOpen(true);
    setOpenpopup(true);
  };
const labelParser = (arr) => {
    let value = [];
    arr.flat().map((obj) => {
        value.push(String(obj.label));
    });
    return value;
};
const handleSubmit = async (values) => {
  setLoad(true);
  const dataToSend = {
    "content": {
        "frequency": values.Frequency,
        "messagebody": values.MessageBody,
        "messagetitle": values.MessageTitle
    },
    "isdeleted": 0,
    "id": 1127,
    "type": 2,
    "resourceid": values.resourceid,
    "category": Array.isArray(values.medicationType) ? values.medicationType[0].value : values.medicationType.value,
    "trigger": labelParser(values.trigger),
    "categorytag": labelParser(values.categorytag),
    "diseasesegment": labelParser(values.diseasesegment),
    "persona": labelParser(values.persona),
    "topictag": labelParser(values.topictag),
    "objective": labelParser(values.objective),
    "treatmentphase": labelParser(values.treatmentphase),
    'drugcategory': labelParser(values.drugcategory)
  };

  let url = "";
  url = '/api/content/contentservice/saveAFBResource';
  const makeDataForRevisionAndVersion = () => {
    dataToSend.id = props.location.state.detail[0].id;
    if(values.medicationType.constructor === Array){
      dataToSend["category"] = values.medicationType[0].value;
    } else {
      dataToSend["category"] = values.medicationType.value;
    }
  };
  if(props.history.location.pathname.includes("revision") && props.location.clone !== "clone"){
    makeDataForRevisionAndVersion();
    url = "/api/content/contentservice/createRevisionForAFBResource";
  }
  if(props.history.location.pathname.includes("version") && props.location.clone !== "clone"){
    makeDataForRevisionAndVersion();
    url = "/api/content/contentservice/createVersionForAFBResource";
  }
  const send = await props.authenticatedApiCall('post', url, dataToSend);
  if(send.status === StatusCodes.OK){
    setHeaderText(`Your AFB has been successfully saved.`);
    setLoad(false);
    setPopup(true);
  }else {
    setHeaderText(`There is some problem in saving your AFB. Please try again.`);
    setErrorPopup(true);
    setLoad(false);
  }
};
const handleCloseDialogSuccess = () => {
  setPopup(false);
    props.history.push('/Home/AFB');
};
const handleCloseDialogError = () => {
  setErrorPopup(false);
};
const handleDisable = () => {
  if(props.location.clone === "clone"){
    return false;
  }
  if(props.location.state){
    return true;
  }
  return false;
};
const successbutton = [<Button className={classes.primaryBtn} onClick={handleCloseDialogSuccess}>Close</Button>];
const button = [<Button className={classes.primaryBtn} onClick={handleCloseDialogError}>Close</Button>];
  return(
    <div>
    <Typography className={classes.heading} component="h5">AFB Template</Typography>
    <Formik
        enableReinitialize={true}
        validator={() => ({})}
        initialValues={initialValues}
        validationSchema={validateWithSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ values, handleChange,validateForm,setFieldError}) => (
            <Form>
            <div className={classes.main}>
              <div className={classes.holder}>
                    <GridContainer>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                        <Resourceid setFieldErrors={setFieldError} disabled={handleDisable}/>
                    </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                      <Fieldtext name={"veevacontentid"} label="Veeva Content ID*" disabled={true}/>
                    </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Trigger triggeroptions={triggerValue}/>
                    </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name={"Frequency"}
                      type="text"
                      component={Textfield}
                      variant="filled"
                      onChange={handleChange}
                      label="Frequency *"
                      className={classes.inputItem}
                    />
                    </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                      <CategoryTag categoryoption={categorytagtAFBValue}/>
                </GridItem>
                <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <TopicTag topictagoption={TopictagAFBValue}/>
                </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name={"MessageTitle"}
                      type="text"
                      component={Textfield}
                      variant="filled"
                      onChange={handleChange}
                      label="Message Title *"
                      className={classes.inputItem}
                    />
                    </GridItem>
                    <GridItem md={12} lg={12} sm={12} xs={12} className={classes.paddingBottom}>
                    <AreaField name={"MessageBody"}  InputProps={{ multiline: true, rows: 4 }}  label="Message *"/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                  <Objective objectiveoption={ObjectiveOptions}/>
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <DiseaseSegment diseaseSegmentoptions={diseaseSegmentAFBValue} />
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <TreatmentPhase treatmentPhaseoptions={treatmentPhaseValue} />
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <DrugCategory drugCategoryoptions={drugCategoryarticleValue} />
                  </GridItem>
                  <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Persona personaoptions={personaAFB} />
                  </GridItem>
                    <GridItem md={4} lg={4} sm={12} xs={12} className={classes.paddingBottom}>
                    <Field
                      name='medicationType'
                      options={medicationType}
                      placeholder="Medication Type *"
                      component={Selectoption}
                      label="Medication Type *"
                      variant="filled"
                      isSearchable={false}
                      className={classes.createUserSelect + " " + "selectstyle"}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                    </GridItem>
                </GridContainer>
              </div>
              </div>
                <Paper style={{ marginTop: "40px", width: "100%",boxShadow:"none",padding:"15px"}}>
                <Grid container style={{paddingBottom:'5px'}}>
                  <Grid item lg={9} md={9} sm={6} xs={6} style={{ width: '100%', textAlign: 'right' }}>
                    <Button onClick={handlePreviewcur} className={classes.cancelBtn} >Preview</Button>
                      {openpopup ? (
                        <JsonPreviewCur open={open} handleClose={handleClose} data={initialValues} values={values} />) : ( "" )}
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={6} style={{ width: '100%' }}>
                    <Button className={classes.createUser} onClick={() => validateForm().then(arg => { console.log(arg); })} type="submit" disabled={disableafbsubmit} >
                    {load && <CircularProgress style={{position:'absolute', top:'-140%', right:'40%'}} />} {"SUBMIT"} </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Form>
          )}
</Formik>

{popup && <SuccessDialog successButton={successbutton} HeaderText="Success" BodyText={headerText} dismiss={handleCloseDialogSuccess} />}
{errorPopup && <ErrorDialog successButton={button} HeaderText={headerText} dismiss={handleCloseDialogError} />}
</div>
   );
  };

export default (AuthenticatedPage()(AddAFB));